import { ProductGroupListing } from '@views/SKUMaster/components/productGroups';
import { InventorySKUListing } from './types';

export const availableProductsOf = (
  sku: InventorySKUListing,
  warehouseId?: string | null
): number =>
  (sku.stockByWarehouse ?? []).reduce((total, stock) => {
    const isOutsideWarehouseFilter =
      warehouseId && warehouseId !== 'All' && stock.warehouseId !== warehouseId;
    if (isOutsideWarehouseFilter) return total;
    return (
      total +
      (stock.availableProducts ?? 0) +
      (stock.availableLooseProducts ?? 0)
    );
  }, 0);

export const skusToChooseFrom = (
  group: ProductGroupListing,
  warehouseId?: string | null
): InventorySKUListing[] =>
  [...(group.skus ?? [])].sort(
    (first, second) =>
      availableProductsOf(second, warehouseId) -
      availableProductsOf(first, warehouseId)
  );

export const despatchTargetOfProduct = (
  group: ProductGroupListing
): InventorySKUListing | null => {
  const skus = skusToChooseFrom(group);
  if (skus.length === 0) return null;
  const holdsMoreThanOneSku = group.skuCount > 1 || skus.length > 1;
  return holdsMoreThanOneSku ? null : skus[0];
};

export const despatchUnitOf = (sku: InventorySKUListing): 'product' | 'sku' =>
  sku.productDetails?.productId ? 'product' : 'sku';
